import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

export default class Sms {
  constructor(token) {
    axios.defaults.baseURL = API_URL + '/v1/notifications/'
    axios.defaults.headers.common['Authorization'] = `Bearer ${token.token}`
  }

  getPhoneNumber(source, userId) {
    const params = userId ? `?source=${source}&user_id=${userId}` : ''
    return axios
      .get('/receiver' + params)
      .then((response) => response.data)
      .catch((error) => error.response)
  }

  setPhone(tokens, data) {
    const instance = axios.create({
      baseURL: API_URL + '/v1/notifications/',
    })
    instance.defaults.headers.common['Authorization'] = tokens
    return instance
      .post('/receiver', data)
      .then((response) => response.data)
      .catch((error) => error.response)
  }

  sendCode(data, tokens) {
    const instance = axios.create({
      baseURL: API_URL + '/v1/notifications/',
    })
    instance.defaults.headers.common['Authorization'] = tokens
    return instance
      .post('/authentication', data)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  }

  checkCode(data, tokens) {
    const instance = axios.create({
      baseURL: API_URL + '/v1/notifications/',
    })
    instance.defaults.headers.common['Authorization'] = tokens
    return instance
      .put('/authentication', data)
      .then((response) => response.data)
      .catch((error) => error.response)
  }

  sendCodeByCellphone(data) {
    return axios
      .post('/code', data)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  }

  checkCodeByCellphone(data) {
    return axios
      .put('/code', data)
      .then((response) => response.data)
      .catch((error) => error.response)
  }
}
